/* @flow */
import AddBankAccountForm from 'payments/components/AddBankAccountForm.jsx';
import AddSchoolAccountForm from 'payments/components/AddSchoolAccountForm.jsx';
import React, { Component, PropTypes } from 'react';
import TabPanel from 'components/TabPanel.jsx';
import Tabs from 'components/Tabs.jsx';

import './styles/AddBankAccountFormContainer.scss';

export default class AddBankAccountFormContainer extends Component {
  static propTypes = {
    onBankAccountAdded: PropTypes.func,
    onSchoolBankAccountAdded: PropTypes.func,
  }

  render() {
    const {
      onSchoolBankAccountAdded,
      onBankAccountAdded,
      ...rest
    } = this.props;

    return (
      <div className="AddBankAccountFormContainer">
        <Tabs className="AddBankAccountFormContainer-tabs" type="button">
          <TabPanel title={<span>Individual account</span>}>
            <AddBankAccountForm {...rest} onBankAccountAdded={onBankAccountAdded} />
          </TabPanel>
          <TabPanel title={<span>School bank account</span>}>
            <AddSchoolAccountForm {...rest} onSchoolBankAccountAdded={onSchoolBankAccountAdded} />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/AddBankAccountFormContainer.jsx